/* eslint-disable prefer-destructuring */
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
class FancyBoxGallery extends HTMLElement {
  constructor() {
    super();
    this.srcs = [];
    this.sliderImages = [];
    this.featuredImage = null;

    this.handleSliderImageClick = this.handleSliderImageClick.bind(this);
    this.handleFeaturedImageClick = this.handleFeaturedImageClick.bind(this);
  }

  connectedCallback() {
    this.initElements();
    this.attachEventListeners();
  }

  disconnectedCallback() {
    this.detachEventListeners();
  }

  initElements() {
    this.srcs = Array.from(this.querySelectorAll(".js-gallery-image:not(.js-product-video)")).map((el) => el.src);
    this.sliderImages = Array.from(this.querySelectorAll(".js-product-gallery__slide-link[data-fancybox]"));
    this.featuredImage = this.querySelector(".js-product-gallery__featured-image");
    this.glassesDesktop = this.querySelector(".js-magnifiyng-glass-gallery--desktop");
  }

  attachEventListeners() {
    this.sliderImages.forEach((image) => image.addEventListener("click", this.handleSliderImageClick));

    if (this.featuredImage) {
      if (this.featuredImage.hasAttribute('data-fancybox')) {
        this.featuredImage.addEventListener("click", this.handleFeaturedImageClick);
      }
    }

    if (this.glassesDesktop) {
      this.glassesDesktop.addEventListener("click", this.handleFeaturedImageClick);
    }
  }

  detachEventListeners() {
    this.sliderImages.forEach((image) => image.removeEventListener("click", this.handleSliderImageClick));

    if (this.featuredImage && this.featuredImage.hasAttribute('data-fancybox')) {
      this.featuredImage.removeEventListener("click", this.handleFeaturedImageClick);
    }
  }

  openFancyboxWithImages(startIndex = 0) {
    if (typeof Fancybox === "undefined") {
      console.error("Fancybox is not defined. Make sure the Fancybox script is loaded.");
      return;
    }

    const images = this.srcs.map((src) => ({
      src,
      type: "image",
    }));

    Fancybox.show(images, { startIndex });
  }

  handleSliderImageClick(event) {
    if (window.innerWidth < 1024) {
      if (event.currentTarget.querySelector(".js-gallery-image:not(.js-product-video)")) {
        const clickedSrc = event.currentTarget.querySelector(".js-gallery-image:not(.js-product-video)").src;
        this.currentSrc = clickedSrc;
        const startIndex = this.srcs.indexOf(clickedSrc);
        this.openFancyboxWithImages(startIndex);
      } else {
        this.openFancyboxWithImages(0);
      }
    }
  }

  handleFeaturedImageClick() {
    if (window.innerWidth >= 1024) {
      const featuredImg = this.featuredImage.querySelector(".js-featured-gallery-image:not(.js-featured-product-video)");
      if (featuredImg) {
        const startIndex = this.srcs.indexOf(featuredImg.src);
        this.openFancyboxWithImages(startIndex);
      }
    }
  }
}

customElements.define("fancy-box-gallery", FancyBoxGallery);
